import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

export const MusthadPreset = definePreset(Aura, {
  semantic: {
    borderRadius: {
      none: 0,
      xs: '0.125rem', // 2px
      sm: '0.25rem', // 4px
      md: '0.375rem', // 6px
      lg: '0.5rem', // 8px
      xl: '0.75rem', // 12px
    },
    primary: {
      50: '#FFF6E7',
      100: '#FFE8BD',
      200: '#FFD993',
      300: '#FFCA69',
      400: '#FFBB40',
      500: '#E39300',
      600: '#D28800',
      700: '#C07D00',
      800: '#A16900',
      900: '#815300',
      950: '#533600',
    },
    light: {
      surface: {
        0: '#FFFFFF',
        50: '#F5F7FA',
        100: '#F2F5F8',
        200: '#E1E4EA',
        300: '#CACFD8',
        400: '#99A0AE',
        500: '#717784',
        600: '#525866',
        700: '#2B303B',
        800: '#222530',
        900: '#181B25',
        950: '#0E121B',
      },
      green: {
        50: '#E0FAEC',
        100: '#D0FBE9',
        200: '#C2F5DA',
        300: '#84EBB4',
        400: '#3EE089',
        500: '#1FC16B',
        600: '#1DAF61',
        700: '#178C4E',
        800: '#1A7544',
        900: '#16643B',
        950: '#0B4627',
      },
      red: {
        50: '#FFEBEC',
        100: '#FFD5D8',
        200: '#FFC0C5',
        300: '#FF97A0',
        400: '#FF6875',
        500: '#FB3748',
        600: '#E93544',
        700: '#D02533',
        800: '#AD1F2B',
        900: '#8B1822',
        950: '#681219',
      },
      sky: {
        50: '#EBF1FF',
        100: '#D5E2FF',
        200: '#C0D5FF',
        300: '#97BAFF',
        400: '#6895FF',
        500: '#335CFF',
        600: '#3559E9',
        700: '#2547D0',
        800: '#1F3BAD',
        900: '#182F8B',
        950: '#122368',
      },
    },
  },
})

export const primaryGhostButtonPt = {
  root: {
    class:
      'bg-primary-50 text-primary border-primary-50 enabled:hover:bg-transparent enabled:hover:border-primary',
  },
}

export const dangerGhostButtonPt = {
  root: {
    class:
      'bg-red-50 text-red-600 border-red-50 enabled:hover:bg-transparent enabled:hover:border-red-600',
  },
}
